import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const OrderDetailsWithIconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  &:last-child {
    margin-bottom: 15px;
  }
  > div {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    display: flex;
    align-items: center;
    span {
      color: ${theme.colours.black};
      font-family: ${theme.fonts.Regular};
      font-weight: 600;
      font-size: 14px;
      display: flex;
    }
    &:first-child {
      span {
        font-size: 14px;
        font-weight: 400;
        svg {
          color: #969696;
          width: 18px;
          height: 18px;
        }
      }
    }
    &:last-child {
      display: flex;
      justify-content: flex-end;
    }
  }
  .custom_button {
    p {
      color: ${theme.colours.mainBlue};
      font-family: ${theme.fonts.Medium};
      font-weight: 600;
      font-size: 14px;
    }
  }
`;
